import { ShopDetails } from 'app-shared/lib/api/catalog/shop';
import { ORDER_TYPE } from 'app-shared/lib/api/shared/order.interfaces';

export const autoSelectOrderTypeIfPossible = (editableTypes: ORDER_TYPE[]) => {
  if (editableTypes.length == 1) return editableTypes[0];

  return null;
};

// LOCAL_COLLECT is always available for staff orders; the other types are gated by the shop's accept flags.
export const getEditableOrderTypes = (shopDetails: ShopDetails): ORDER_TYPE[] => {
  const editableTypes: ORDER_TYPE[] = ['LOCAL_COLLECT'];

  if (shopDetails.isClickAndCollectAccepted) {
    editableTypes.push('CLICK_AND_COLLECT');
  }

  if (shopDetails.isDeliveryAccepted) {
    editableTypes.push('DELIVERY');
  }

  return editableTypes;
};
